<template>
    <div class="shadow-lg h-16 z-10 w-screen flex items-center px-4 bg-blue-800 text-blue-100 font-bold fixed top-0">
        <div>Trending Github Repos</div>
    </div>
</template>

<script>
export default {
    name: "TheHeader"
}
</script>